import { isValid, parse } from "date-fns";
import { isTodayOrFutureDate, isValidMilesAndMoreNumber } from "./airlineLandingHelpers";

export type AirlineLandingUrlPrefill = {
  mamid: string | null;
  arrivalDate: Date | null;
  airportIata: string | null;
};

const ARRIVAL_DATE_PATTERN = /^\d{2}-\d{2}-\d{4}$/;

const normalizeParam = (value: string | null): string | null => {
  if (value == null) {
    return null;
  }

  const trimmed = value.trim();
  return trimmed || null;
};

const parseArrivalDateParam = (value: string | null): Date | null => {
  if (!value || !ARRIVAL_DATE_PATTERN.test(value)) {
    return null;
  }

  const parsedDate = parse(value, "dd-MM-yyyy", new Date());
  if (!isValid(parsedDate) || !isTodayOrFutureDate(parsedDate)) {
    return null;
  }

  return parsedDate;
};

export const parseAirlineLandingPrefillFromSearch = (search: string): AirlineLandingUrlPrefill => {
  const params = new URLSearchParams(search.startsWith("?") ? search : `?${search}`);

  const mamid = normalizeParam(params.get("mamid"));
  const arrivalDateParam = normalizeParam(params.get("arrival_date"));
  const airportIata = normalizeParam(params.get("airport"));

  return {
    mamid: mamid && isValidMilesAndMoreNumber(mamid) ? mamid : null,
    arrivalDate: parseArrivalDateParam(arrivalDateParam),
    airportIata
  };
};
